export default __webpack_public_path__ + "static/media/det-aene-am-baergli.c4c61bcb.pdf";